// extracted by mini-css-extract-plugin
module.exports = {"cancelled":"styles__cancelled___3JRf8","warning":"styles__warning___1vF-k"};